export const NEW_DEMAND_MAX_LENGTH = 500;

export const YES_NO_OPTIONS = ['Yes', 'No'] as const;

// Temporary options until backend reference data is available.
export const BUSINESS_UNIT_OPTIONS: readonly string[] = [
  'R&D BioPharmaceuticals',
  'Information Technology',
  'Finance',
  'Operations',
  'Enterprise AI',
  'R&D Oncology',
  'International',
  'Alexion - AstraZeneca Rare Diseases',
  'Japan and Corporate Strategy',
  'Human Resources',
  'GPPM, Strategic Planning, BDO and Deal Finance',
  'AZ (Enterprise)',
  'Oncology',
  'BioPharmaceuticals',
  'Legal',
  'Global Sustainability',
  'US BBU',
  'Global Medicines Development',
  'Global Business Services',
  'Vaccines & Immune Therapies',
  'Enterprise Cell Therapy Unit',
  'Research and Product Development',
  'Global Corporate Affairs',
  'Compliance',
  'Global Engineering & Real Estate',
  'Chair, AstraZeneca UK',
  'Global Portfolio & Project Management',
  'Security & Business Resilience',
];

export const INFORMATION_CLASSIFICATION_OPTIONS: readonly string[] = [
  'Confidential',
  'Internal',
  'Unrestricted',
];

export const IT_FUNCTION_DEPARTMENT_OPTIONS = INFORMATION_CLASSIFICATION_OPTIONS;

export const COUNTRY_OPTIONS: readonly string[] = [
  'Algeria',
  'Argentina',
  'Australia',
  'Austria',
  'Belgium',
  'Brazil',
  'Bulgaria',
  'Canada',
  'Chile',
  'China',
  'Colombia',
  'Costa Rica',
  'Croatia',
  'Czech Republic',
  'Denmark',
  'Egypt',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Holland',
  'Hong Kong',
  'Hungary',
  'India',
  'Indonesia',
  'Israel',
  'Italy',
  'Japan',
  'Kenya',
  'Latvia',
  'Lithuania',
  'Luxembourg',
  'Malaysia',
  'Mexico',
  'Netherlands',
  'Norway',
  'Philippines',
  'Poland',
  'Portugal',
  'Republic of China',
  'Republic of Ireland',
  'Republic of Korea',
  'Romania',
  'Russian Federation',
  'Singapore',
  'South Africa',
  'Switzerland',
  'Thailand',
  'Tunisia',
  'Turkey',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United Kingdom (only England and Wales)',
  'United States of America',
  'Uruguay',
  'Venezuela',
];
